
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-demo-think","docs-x-markdown-components-demo-thoughtchain"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components.en-US.md?type=demo')
};